import { render, staticRenderFns } from "./studentscore.vue?vue&type=template&id=26e52d5c&"
import script from "./studentscore.vue?vue&type=script&lang=js&"
export * from "./studentscore.vue?vue&type=script&lang=js&"
import style0 from "./studentscore.vue?vue&type=style&index=0&id=26e52d5c&prod&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports